import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getLiveTourExperience, resetLiveTourExperience } from '../../store/actions/experience';
import { navigateSpace } from '../../store/actions/app';
import { RootState } from '../../types/data';
import { ExperiencePhotoSpace } from '../../containers/xr/space';
import { Helmet } from 'react-helmet';

type LiveTourExperienceRouteProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<{ experienceId: string }>;

const mapStateToProps = (state: RootState) => ({
  experience: state.experience.current,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getLiveTourExperience,
      resetLiveTourExperience,
      navigateSpace,
    },
    dispatch
  );

const LiveTourExperienceRoute = ({ experience, ...props }: LiveTourExperienceRouteProps) => {
  const { experienceId } = props.match.params;

  // data fetching functional
  useEffect(() => {
    props.getLiveTourExperience(experienceId);
    return () => {
      props.resetLiveTourExperience();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [experienceId]);

  // useEffect(() => {
  //   if (experience.loaded && experience.data) {
  //     GatewayService.emit(EXPERIENCE_LOADED, experience.data);
  //   }
  // }, [experience.loaded, experience.data]);

  if (!experience.loaded) {
    return null;
  }

  const pageTitle = experience.data?.title;

  return (
    <>
      <Helmet>{pageTitle ? <title>{`${pageTitle} | 360 Stories`} </title> : null}</Helmet>
      <ExperiencePhotoSpace data={experience.data.points} />
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LiveTourExperienceRoute));
